import SwiperCore from 'swiper/core';
import Swiper, { Navigation } from 'swiper';
import { Breakpoint } from '../../../types/breakpoint';
export default class SubNavSlider {
    static $slider = $('.js__sub-nav-slider');
    static swiper;
    static options = {
        centeredSlides: false,
        slidesPerView: 3,
        centerInsufficientSlides: true,
        spaceBetween: 10,
        watchOverflow: true,
        breakpoints: {
            [Breakpoint.lg]: {
                slidesPerView: 7,
                spaceBetween: 24,
                centeredSlides: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        SwiperCore.use([Navigation]);
        this.swiper = new Swiper(this.$slider.get(0), {
            ...this.options,
        });
    }
}
